// @flow
import { ActionType as SelectionActionType } from "bb-selection-picker";
import { ActionType as BetslipActionType } from "bb-betslip";
import { ActionType as TabActionType } from "bb-tab-selector";
import { configureStore } from "bb-conductor";
import loadStore from "./storeLoader";
/**
 * Define the inbound and outbound messages to/from this components store
 *
 * @ignore
 * @type {{inbound: *[], outbound: *[]}}
 */
const config = {
  inbound: [
    SelectionActionType.ADD_SELECTION,
    SelectionActionType.REMOVE_SELECTION,
    SelectionActionType.FETCH_MARKETS_SUCCESS,
    SelectionActionType.FETCH_MARKETS_FAILURE,
    BetslipActionType.CLEAR_SELECTIONS,
    BetslipActionType.ADD_BET_SUCCESS,
    BetslipActionType.ADD_BET_FAILURE,
    BetslipActionType.ADD_BET_REQUEST,
    BetslipActionType.REMOVE_SELECTIONS_SUCCESS,
    BetslipActionType.REMOVE_SELECTIONS_FAILURE,
    BetslipActionType.ADD_SELECTIONS_SUCCESS,
    BetslipActionType.ADD_SELECTIONS_FAILURE,
    TabActionType.SWITCHED_TAB
  ],
  outbound: [
    SelectionActionType.RESET_SELECTIONS,
    SelectionActionType.DISABLED_SELECTIONS,
    SelectionActionType.LOAD_SELECTIONS,
    SelectionActionType.UNLOAD_SELECTIONS,
    SelectionActionType.ACTIVE_SELECTIONS,
    SelectionActionType.FILTER_MARKETS,
    SelectionActionType.USER_INTERACTION_ENABLED,
    BetslipActionType.ADD_SELECTIONS_REQUEST,
    BetslipActionType.REMOVE_SELECTIONS_REQUEST,
    BetslipActionType.USER_INTERACTION_ENABLED,
    TabActionType.UPDATE_MARKETS,
    BetslipActionType.FETCH_MARKETS_FAILURE
  ]
};

/**
 * Creates the conductor store
 *
 * @ignore
 */
const conductorStore = () => loadStore(config, configureStore);

export default conductorStore;



// WEBPACK FOOTER //
// ./src/stores/conductorStore.js